import { Outlet, useOutletContext } from "react-router-dom";
import { AmortizationTypeProvider } from "domain/AmortizationType";
import { CategoriesProvider } from "domain/Category";
import { CensusProvider } from "domain/Census";
import { CompaniesProvider } from "domain/Company";
import { SmallInventoryValueProvider } from "domain/SmallInventoryValue";
import { SuppliersProvider } from "domain/Supplier/context";

// Lists shared by the home and item pages, loaded once instead of on every page switch.
export const SharedListsProvider = () => {
  const outletContext = useOutletContext();

  return (
    <CategoriesProvider>
      <CompaniesProvider>
        <CensusProvider>
          <SuppliersProvider>
            <SmallInventoryValueProvider>
              <AmortizationTypeProvider>
                <Outlet context={outletContext} />
              </AmortizationTypeProvider>
            </SmallInventoryValueProvider>
          </SuppliersProvider>
        </CensusProvider>
      </CompaniesProvider>
    </CategoriesProvider>
  );
};
